<template>
    <el-dialog
        :visible.sync="visible"
        custom-class="login-dialog"
        width="640px"
        top="50vh"
        :show-close="true"
        :close-on-click-modal="false"
        :before-close="handleClose"
    >
        <div class="login-con">
            <img src="../assets/login-logo.png" class="logo" alt="">
            <div class="space"></div>
            <div class="login-container">
                <div class="register-option">
                    <span :class="['register-link', tab === 'login' && 'active']"
                        @click="changeTab('login')">短信登录</span>
                </div>

                <!-- 登录表单 -->
                <el-form :model="loginForm" :rules="loginRules" ref="loginForm" label-width="0px" class="login-form">
                    <el-form-item prop="phoneNumber">
                        <el-input class="login-input" v-model="loginForm.phoneNumber" placeholder="请输入手机号">
                            <template #prefix>
                                <img src="../assets/icon-user.png" alt="" class="pre-icon">
                            </template>
                        </el-input>
                    </el-form-item>

                    <el-row :gutter="10">
                        <el-col :span="16">
                            <el-form-item prop="code">
                                <el-input class="login-input" v-model="loginForm.code" placeholder="请输入短信验证码">
                                    <template #prefix>
                                        <img src="../assets/icon-safe.png" alt="" class="pre-icon">
                                    </template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <button :class="['code-btn', isDisabled && 'code-disabled']" @click.prevent="handleSendCaptcha" :disabled="isDisabled">{{ btnText }}</button>
                        </el-col>
                    </el-row>

                    <!-- 登录按钮 -->
                    <el-form-item class="login-btn-container">
                        <el-button type="primary" :loading="loginLoading" class="login-btn" @click="submitLogin">登录</el-button>
                    </el-form-item>
                </el-form>
                <span class="refresh-link" @click.prevent="refreshPage">页面有问题？刷新缓存</span>
                <IcpBeian class="login-icp" />
            </div>
        </div>
    </el-dialog>
</template>

<script>
import { captchaImage, register, login, sendLoginMsg, msgLogin } from '@/api'
import { applyUserDataToStorage } from '@/utils/userSession'
import IcpBeian from '@/components/IcpBeian.vue'
export default {
    components: {
        IcpBeian,
    },
    props: {
        loginDialogVisible: {
            default: false,
            require: true
        }
    },
    data() {
        return {
            visible: this.loginDialogVisible,
            loginLoading: false,

            // 表单数据
            loginForm: {
                phoneNumber: '',
                code: ''
            },

            // 表单验证规则
            loginRules: {
                phoneNumber: [
                    { required: true, message: '请输入手机号', trigger: 'blur' }
                ],
                code: [
                    { required: true, message: '请输入验证码', trigger: 'blur' }
                ]
            },
            timer: null,
            seconds: 60,
            btnText: '发送验证码',
            isDisabled: false,
            tab: 'login'
        };
    },
    watch: {
        loginDialogVisible(val) {
            this.visible = val
            if (val) {
                this.$nextTick(() => {
                    this.$refs.loginForm.resetFields();
                    if (this.tab === 'login') {
                        const account = JSON.parse(localStorage.getItem('account') || '{}')
                        this.$set(this.loginForm, 'phoneNumber', account.phoneNumber)
                    }
                })
            }
        }
    },

    methods: {
        handleClose(done) {
            // 在这里可以添加关闭前的逻辑，例如清除表单
            this.$refs.loginForm.resetFields();
            this.$emit('update:loginDialogVisible', false)
            done();
        },
      // 发送短信验证码
      handleSendCaptcha() {
        if (!/^1[3-9]\d{9}$/.test(this.loginForm.phoneNumber)) {
          this.$message.warning('请输入正确手机号');
          return;
        }
        sendLoginMsg(this.loginForm.phoneNumber).then(res => {
            this.isDisabled = true
            this.timer = setInterval(() => {
              this.seconds--
              this.btnText = `重新获取(${this.seconds}s)`

              // 倒计时结束
              if (this.seconds <= 0) {
                if (this.timer) {
                  clearInterval(this.timer)
                  this.timer = null
                }
                // 重置状态
                this.isDisabled = false
                this.btnText = '发送验证码'
                this.seconds = 60
              }
            }, 1000)

            this.$message.success('验证码已发送');
        }).catch(err => {
          this.$message.error(err.message)
        });
      },

        // 切换tab
        changeTab(value) {
            if (value === this.tab) return
            this.$refs.loginForm.resetFields();
            this.tab = value
            if (value === 'login' && localStorage.getItem('account')) {
                const account = JSON.parse(localStorage.getItem('account'))
                this.$set(this.loginForm, 'phoneNumber', account.phoneNumber)
            }
        },
        // 提交表单
        submitLogin() {
            this.$refs.loginForm.validate(valid => {
                if (valid) {
                    this.loginLoading = true;
                    const phoneNumber = this.loginForm.phoneNumber;
                    const code = this.loginForm.code;

                    msgLogin(phoneNumber, code).then((res) => {

                      if (res.success == true) {
                        applyUserDataToStorage(res.data, phoneNumber, { renewLoginTime: true });
                        this.loginLoading = false;
                        this.$message.success('登录成功！');
                        this.$emit('updatePage', false);
                      }
                    }).catch(() => {
                        this.loginLoading = false;
                        this.$refs.loginForm.resetFields();
                    });
                } else {
                    return false;
                }
            });
        },
        // 刷新页面
        refreshPage() {
            // 刷新页面逻辑
            location.reload();
        }
    },
  destroyed () {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }
};
</script>

<style scoped lang="scss">
.login-con {
    width: 100%;
    min-height: 720px;
    padding: 72px 52px 28px;
    position: relative;
    display: flex;
    flex-direction: column;

    .logo {
        width: 250px;
        height: 54px;
    }

    .space {
        height: 104px;
        flex: 0 0 104px;
    }

    .login-container {
        display: flex;
        flex: 1;
        flex-direction: column;
    }

    .register-option {
        margin-bottom: 42px;

        .register-link {
            font-weight: 600;
            font-size: 24px;
            color: #666666;
            line-height: 33px;
            padding-bottom: 6px;
            cursor: pointer;

            &+.register-link {
                margin-left: 84px;
            }

            &.active {
                border-bottom: 4px solid #2683BE;
            }
        }
    }

    .login-input {
        .pre-icon {
            margin-top: 21px;
            margin-left: 15px;
            width: 12px;
        }

        :deep(.el-input__inner) {
            height: 58px;
            padding-left: 50px;
        }
    }

    .login-btn {
        background-color: transparent;
        border: 0;
        width: 100%;
        height: 86px;
        background-image: url('../assets/btn-bg.png');
        background-size: 100% 100%;
        font-size: 24px;
        color: #FFFFFF;
    }

    .refresh-link {
        font-weight: 600;
        font-size: 18px;
        color: #2683BE;
        line-height: 25px;
        display: block;
        margin-top: auto;
        text-align: center;
        cursor: pointer;
    }

    .login-icp {
        margin-top: 18px;
        width: 100%;
    }

  .code-btn {
    height: 58px;
    width: 100%;
    border-radius: 10px;
    background: #fff;
    border: 1px solid #b6c5cc;
    color: #000;
    font-weight: bold;
    font-size: 18px;
    cursor: pointer;
    overflow: hidden;
  }
  .code-disabled {
    background: #f5f5f5;
  }
}

@media (max-width: 768px) {
  .login-con {
    min-height: min(680px, calc(100vh - 32px));
    padding: 44px 22px 24px;

    .logo {
      width: 200px;
      height: auto;
    }

    .space {
      height: 48px;
      flex-basis: 48px;
    }

    .register-option {
      margin-bottom: 28px;

      .register-link {
        font-size: 20px;
        line-height: 28px;
      }
    }

    .login-input {
      .pre-icon {
        margin-top: 17px;
      }

      :deep(.el-input__inner) {
        height: 50px;
        padding-left: 44px;
      }
    }

    .login-btn {
      height: 84px;
      font-size: 20px;
    }

    .code-btn {
      height: 50px;
      font-size: 13px;
    }

    .refresh-link {
      display: block;
      font-size: 14px;
      line-height: 20px;
    }

    .login-icp {
      margin-top: 18px;
    }
  }
}
</style>

<style lang="scss">
.login-dialog {
  max-width: calc(100vw - 32px);
  margin-top: 50vh !important;
  transform: translateY(-50%);
  border-radius: 16px;
  overflow: hidden;

  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__headerbtn {
    top: 18px;
    right: 18px;
    z-index: 2;
  }

  .el-dialog__body {
    padding: 0;
  }
}

@media (max-width: 768px) {
  .login-dialog {
    width: calc(100vw - 24px) !important;
    max-height: calc(100vh - 24px);

    .el-dialog__body {
      max-height: calc(100vh - 24px);
      overflow-y: auto;
    }
  }
}
</style>
